import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/DemurrageAndDetention/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = (): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>

        <div className={cn('header__image-box')}>
          <picture>
            <source
              srcSet="/images/pages/Resources/DemurrageAndDetention/map-desktop@2x.png 2x, 
                      /images/pages/Resources/DemurrageAndDetention/map-desktop.png 1x"
              sizes="100vw"
            />
            <source
              srcSet="/images/pages/Resources/DemurrageAndDetention/map-tablet@2x.png 2x, 
                      /images/pages/Resources/DemurrageAndDetention/map-tablet.png 1x"
              sizes="100vw"
              media="(max-width: 768px)"
            />
            <source
              srcSet="/images/pages/Resources/DemurrageAndDetention/map-mobile@2x.png 2x, 
                      /images/pages/Resources/DemurrageAndDetention/map-mobile.png 1x"
              sizes="100vw"
              media="(max-width: 575px)"
            />
            <img
              className={cn('header__image')}
              src="/images/pages/Resources/DemurrageAndDetention/map-desktop.png"
              alt="Map"
            />
          </picture>
        </div>

        <div className={cn('header__description')}>
          <h1 className={cn('header__heading')}>Demurrage and Detention</h1>
          <div className={cn('header__paragraphs')}>
            <p className={cn('header__paragraph')}>
              Among the many challenges importers and shippers face, understanding Demurrage and
              Detention fees is crucial. These charges, often a source of frustration, can significantly impact
              your bottom line if not managed effectively; demurrage costs, in particular, can quickly add up
              and lead to substantial financial losses.
            </p>
            <p className={cn('header__paragraph')}>
              DF Alliance understands the critical role of clear and efficient logistics management, equipping
              you with the insights and tools necessary to manage these costs effectively.
            </p>
            <p className={cn('header__paragraph')}>
              By utilising your member benefits, such as our logistics tools, members can optimise their
              operations and enhance overall efficiency, profitability, and smoother supply chain operations.
              These improvements directly benefit customers by ensuring timely deliveries and reducing
              unnecessary costs.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default SectionHeader;